// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Like extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>Curtir</title>
        <desc>Ícone de uma mão com polegar para cima</desc>
        <g id="icon-like">
          <path d="M24,10a2,2,0,0,0-2-2H14V5c0-3-1-5-3-5a1,1,0,0,0-1,1V5c0,4-4,4-4,4A2,2,0,0,0,4,7H2A2,2,0,0,0,0,9V22a2,2,0,0,0,2,2H4a2,2,0,0,0,2-2v-.46A9.24,9.24,0,0,0,12,24h7a2,2,0,0,0,0-4h1a2,2,0,0,0,0-4h1a2,2,0,0,0,0-4h1A2,2,0,0,0,24,10Z" />
        </g>
      </svg>
    );
  }
}

export default Like;
